import { useIntl } from "react-intl";
import styles from "./Informations.module.scss";

export const Informations = () => {
  const intl = useIntl();

  return (
    <div className={styles.informations}>
      <div className={styles.placeholder}>
        {intl.formatMessage({ id: "informations" })}
      </div>
    </div>
  );
};
